import axios from 'axios';
export default {
    requestSettings(type, form) {
        if (type == 'put') {
            return axios.put(`${process.env.API_URL}/web-settings/${form.id}`, form);
        }
        else if (type == 'post') {
            return axios.post(`${process.env.API_URL}/web-settings`, form);
        } else if (type == 'delete') {
            return axios.delete(`${process.env.API_URL}/web-settings/${form.id}`);
        }
        else {
            return axios.get(`${process.env.API_URL}/web-settings`);
        }
    },
    getByKey(data) {
        return axios.post(`${process.env.API_URL}/web-settings-by-key`, { key: data });
    },
    getById(id) {
        return axios.get(`${process.env.API_URL}/web-settings/${id}`);
    },
    getScheduleSettings() {
        return axios.get(`${process.env.API_URL}/get-schedule-delivery-settings`);
    },
    updateScheduleSettings(data) {
        return axios.post(`${process.env.API_URL}/update-schedule-delivery-settings`, data);
    },

    getAreasPostalCodes() {
        const given_areas = [];
        given_areas.push("02127");
        given_areas.push("02118");
        given_areas.push("02123");
        given_areas.push("02116");
        given_areas.push("02108");
        given_areas.push("02215");
        given_areas.push("02120");
        given_areas.push("02474");
        given_areas.push("02476");
        given_areas.push("02134");
        given_areas.push("02478");
        given_areas.push("02135");
        given_areas.push("02445");
        given_areas.push("02446");
        given_areas.push("02138");
        given_areas.push("02138");
        given_areas.push("02139");
        given_areas.push("02140");
        given_areas.push("02141");
        given_areas.push("02142");
        given_areas.push("02163");
        given_areas.push("02238");
        given_areas.push("02150");
        given_areas.push("02108");
        given_areas.push("02109");
        given_areas.push("02110");
        given_areas.push("02111");
        given_areas.push("02112");
        given_areas.push("02117");
        given_areas.push("02118");
        given_areas.push("02127");
        given_areas.push("02113");
        given_areas.push("02114");
        given_areas.push("02115");
        given_areas.push("02116");
        given_areas.push("02123");
        given_areas.push("02128");
        given_areas.push("02133");
        given_areas.push("02163");
        given_areas.push("02196");
        given_areas.push("02199");
        given_areas.push("02205");
        given_areas.push("02206");
        given_areas.push("02212");
        given_areas.push("02215");
        given_areas.push("02266");
        given_areas.push("02283");
        given_areas.push("02201");
        given_areas.push("02203");
        given_areas.push("02204");
        given_areas.push("02210");
        given_areas.push("02211");
        given_areas.push("02217");
        given_areas.push("02222");
        given_areas.push("02241");
        given_areas.push("02284");
        given_areas.push("02293");
        given_areas.push("02295");
        given_areas.push("02297");
        given_areas.push("02298");
        given_areas.push("02129");
        given_areas.push("02467");
        given_areas.push("02121");
        given_areas.push("02122");
        given_areas.push("02124");
        given_areas.push("02125");
        given_areas.push("02149");
        given_areas.push("02130");
        given_areas.push("02148");
        given_areas.push("02153");
        given_areas.push("02155");
        given_areas.push("02176");
        given_areas.push("02492");
        given_areas.push("02461");
        given_areas.push("02464");
        given_areas.push("02459");
        given_areas.push("02465");
        given_areas.push("02458");
        given_areas.push("02462");
        given_areas.push("02151");
        given_areas.push("02118");
        given_areas.push("02119");
        given_areas.push("02120");
        given_areas.push("02170");
        given_areas.push("02169");
        given_areas.push("02171");
        given_areas.push("02269");
        given_areas.push("02144");
        given_areas.push("02145");
        given_areas.push("02451");
        given_areas.push("02452");
        given_areas.push("02453");
        given_areas.push("02454");
        given_areas.push("02472");
        given_areas.push("02471");
        given_areas.push("02477");
        given_areas.push("02482");
        given_areas.push("02132");
        given_areas.push("01890");
        return given_areas;
    }

}


// WEBPACK FOOTER //
// ./src/Apis/webSettings.js